import { render, staticRenderFns } from "./DepartmentItems.vue?vue&type=template&id=1220a3a7"
import script from "./DepartmentItems.vue?vue&type=script&lang=js"
export * from "./DepartmentItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports